import { createAction, props } from '@ngrx/store';
import { OracleStorageActionModel } from '@models/common/oracle-storage-action.model';
import { GeneralConfigModel } from '@models/configuration/general-config.model';

export const createGeneralConfig = createAction(
    '[GeneralConfig] Create GeneralConfig',
    props<{ action: OracleStorageActionModel<GeneralConfigModel> }>()
);

export const createGeneralConfigSuccess = createAction(
    '[GeneralConfig] Create GeneralConfig Success',
    props<{ GeneralConfig: GeneralConfigModel }>()
);

export const searchGeneralConfigs = createAction(
    '[GeneralConfigs] Search GeneralConfigs',
    props<{ action: OracleStorageActionModel<GeneralConfigModel> }>()
);

export const searchGeneralConfigsSuccess = createAction(
    '[GeneralConfigs] Search GeneralConfigs Success',
    props<{ GeneralConfigs: GeneralConfigModel[] }>()
);

export const updateGeneralConfig = createAction(
    '[GeneralConfig] Update GeneralConfig',
    props<{ action: OracleStorageActionModel<GeneralConfigModel> }>()
);

export const updateGeneralConfigSuccess = createAction(
    '[GeneralConfig] Update GeneralConfig Success',
    props<{ GeneralConfig: GeneralConfigModel }>()
);

export const selectGeneralConfig = createAction(
    '[GeneralConfig] Select GeneralConfig',
    props<{ GeneralConfig: GeneralConfigModel }>()
);

export const deleteGeneralConfig = createAction(
    '[GeneralConfig] Delete GeneralConfig',
    props<{ action: OracleStorageActionModel<GeneralConfigModel> }>()
);

export const deleteGeneralConfigSuccess = createAction(
    '[GeneralConfig] Delete GeneralConfig Success',
    props<{ GeneralConfig: GeneralConfigModel }>()
);

export const resetLoading = createAction(
    '[Loading] Reset Loading Success'
);
